export default __webpack_public_path__ + "static/media/pronounciation.1a5fa4cc.png";